export default __webpack_public_path__ + "static/media/wQ.c5bd11dc.svg";